import { ComparatorSelectProps } from './types';
import { useComparatorOptions } from './hooks';
import { useComparatorValue } from './hooks/useComparatorValue';
import { useOnComparatorChange } from './hooks/useOnComparatorChange';
import { useVisualComponentsContext } from '../../../contexts/visualComponents';
import { useQueryStateContext } from '../../../contexts';
import { useTranslation } from '../../../hooks/useTranslation';

export const ComparatorSelect = ({
  dataType,
  field,
  fieldType,
  onChange,
  isInvalid,
  hasWarning,
  isOpenByDefault,
}: ComparatorSelectProps) => {
  const { t } = useTranslation();
  const { ConditionComparatorSelect } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();
  const options = useComparatorOptions();
  const comparatorValue = useComparatorValue();
  const onComparatorChange = useOnComparatorChange(onChange);

  return (
    <ConditionComparatorSelect
      dataType={dataType}
      field={field}
      isOpenByDefault={isOpenByDefault}
      fieldType={fieldType}
      value={comparatorValue}
      options={options}
      hasError={!!isInvalid}
      hasWarning={hasWarning}
      isDisabled={isReadOnly}
      onChange={onComparatorChange}
      placeholder={t('v2.conditionBuilder.comparatorSelectPlaceholder')}
    />
  );
};
